import React, { useState } from 'react';
import './Antrag.css';
import { FaTrash, FaCloudUploadAlt } from 'react-icons/fa';
import axios from 'axios';
import { API_BASE_URL } from '../../constants';
import { toast } from 'react-toastify';
import { limitFileName } from '../../helpers/limitFileName';

interface OtherDocumentFormProps {
    formData: {
        description: string;
        name: string;
        guid: string;
    }
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleDelete: () => void;
    index: number;
    isViewOnly: boolean;
    antragId: number;
    onUploadSuccess: (fileName: string, guid: string) => void;
}

const OtherDocumentForm: React.FC<OtherDocumentFormProps> = ({
    formData,
    onChange,
    handleDelete,
    index,
    isViewOnly,
    antragId,
    onUploadSuccess
}) => {
    const [isUploading, setIsUploading] = useState(false);

    const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || !antragId || !formData.description) {
            if (!antragId) {
                toast.error('Bitte speichern Sie zuerst den Antrag');
            }
            if (!formData.description) {
                toast.error('Bitte geben Sie zuerst eine Beschreibung ein');
            }
            return;
        }

        const file = e.target.files[0];
        setIsUploading(true);

        try {
            const reader = new FileReader();

            reader.onload = async () => {
                try {
                    const base64String = (reader.result as string).split(',')[1];
                    const uploadFileName = limitFileName(file.name);

                    const documentUploadItem = {
                        fileName: uploadFileName,
                        mimeType: file.type,
                        binaryData: base64String,
                        description: formData.description
                    };

                    const url = `${API_BASE_URL}/application/document?antragId=${antragId}`;

                    const response = await axios.post(url, documentUploadItem, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${sessionStorage.getItem('token')}`
                        }
                    });

                    const guid = typeof response.data === 'string'
                        ? response.data
                        : (response.data.guid || response.data);

                    onUploadSuccess(uploadFileName, guid);

                    setIsUploading(false);
                } catch (error) {
                    console.error(`Error uploading file ${file.name}:`, error);
                    toast.error(`Fehler beim Hochladen von ${file.name}`);
                    setIsUploading(false);
                }
            };

            reader.onerror = (error) => {
                console.error("Error reading file:", error);
                toast.error(`Fehler beim Lesen von ${file.name}`);
                setIsUploading(false);
            };

            reader.readAsDataURL(file);
        } catch (error) {
            console.error(`Error processing file ${file.name}:`, error);
            setIsUploading(false);
        }

        e.target.value = '';
    };

    return (
        <div className={`antrag-ausbildung ${index === 0 ? '' : 'document-description'}`} style={{ marginLeft: '4px' }}>
            <div style={{ textAlign: "left" }}>
                <label className='form-label' htmlFor={`description-${index}`}>Kurze Beschreibung des Dokuments</label>
                <input
                    tabIndex={isViewOnly ? -1 : 0}
                    id={`description-${index}`}
                    className='form-control'
                    type='text'
                    name='description'
                    value={formData.description}
                    onChange={onChange}
                    style={{ width: '100%', padding: '5px' }}
                    maxLength={100}
                />
            </div>

            <div style={{ alignContent: 'center' }}>
                <div className='form-group-ausbildung'>
                    <input
                        tabIndex={isViewOnly ? -1 : 0}
                        style={{ display: 'none' }}
                        type='file'
                        name='documentLink'
                        id={`andere-dokumente-${index}`}
                        accept='.pdf,.png,.jpg'
                        className='input-file'
                        onChange={handleFileUpload}
                        multiple={false}
                        disabled={formData.description === ''}
                    />
                    <label
                        htmlFor={`andere-dokumente-${index}`}
                        className={`upload-btn ${formData.description === '' ? 'disabled' : ''}`}>
                        <FaCloudUploadAlt /> Datei hochladen
                    </label>
                </div>
            </div>

            <div>
                <div className='form-group-ausbildung'>
                    <div className='file-upload'>
                        {isUploading && (
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        )}
                        {!isUploading && formData.name && (
                            <div className='file'>
                                <span>{formData.name}</span>
                                <button
                                    type='button'
                                    className='delete-file'
                                    title='Entfernen Sie diese Datei'
                                    onClick={handleDelete}
                                    tabIndex={isViewOnly ? -1 : 0}
                                >
                                    <FaTrash />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OtherDocumentForm;